<template>
  <!--
    Lo que va con la próxima pregunta: fotos, un PDF, un correo de la bandeja.

    Encima de la caja y no dentro: una fila de fichas que se ve antes de
    mandar, con su × cada una. La cámara y el carrete son los de UiMediaPicker
    —la misma puerta que el parte o una incidencia, comprimida igual, y sin
    getUserMedia: es el selector del sistema (§4.5)—; el PDF va por su propio
    botón porque el carrete solo ofrece fotos. Nada sube hasta que se manda:
    adjuntar y arrepentirse no ha costado nada.
  -->
  <div v-if="store.attachments.length || store.attachOpen" class="attach">
    <ul v-if="store.attachments.length" class="attach__chips">
      <li v-for="item in store.attachments" :key="item.key" class="chip">
        <img v-if="item.url" :src="item.url" alt="" class="chip__thumb" />
        <span v-else class="chip__icon" aria-hidden="true">{{ item.kind === 'email' ? '✉' : '📄' }}</span>
        <span class="chip__name">{{ item.name }}</span>
        <button
          type="button"
          class="chip__drop"
          :title="t('assistant.attach.remove')"
          :aria-label="t('assistant.attach.remove')"
          @click="store.removeAttachment(item.key)"
        >×</button>
      </li>
    </ul>

    <div v-if="store.attachOpen && room > 0" class="attach__pick">
      <UiMediaPicker
        :model-value="[]"
        :video="false"
        :max="room"
        :hint="t('assistant.attach.hint')"
        @update:model-value="files => store.addFiles(files)"
      />
      <button type="button" class="attach__doc" @click="documentInput?.click()">
        {{ t('assistant.attach.document') }}
      </button>
      <input
        ref="documentInput"
        type="file"
        class="attach__input"
        accept="application/pdf,text/plain,text/csv"
        @change="onDocument"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { UiMediaPicker } from '@general/ui-kit'

import { useAssistantStore } from '../store'

const { t } = useI18n()
const store = useAssistantStore()
const documentInput = ref(null)

const room = computed(() => 4 - store.attachments.length)

function onDocument(event) {
  const chosen = [...(event.target.files ?? [])]
  // Vaciado ya: el mismo PDF dos veces seguidas no dispara otro change.
  event.target.value = ''
  if (chosen.length) store.addFiles(chosen)
}
</script>

<style scoped>
.attach {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3) 0;
  border-top: 1px solid var(--color-border);
  background: var(--color-surface);
}

.attach__chips { display: flex; flex-wrap: wrap; gap: var(--space-2); margin: 0; padding: 0; list-style: none; }

.chip {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  max-width: 100%;
  padding: 2px 2px 2px var(--space-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface-2);
  font-size: var(--text-xs);
}
.chip__thumb { width: 28px; height: 28px; object-fit: cover; border-radius: var(--radius-sm); }
.chip__icon { font-size: 16px; }
.chip__name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 16ch; }
.chip__drop {
  /* 32px de diana en una ficha de 28: se pulsa con el pulgar. */
  width: 32px;
  height: 32px;
  border: none;
  background: none;
  color: var(--color-text-soft);
  font-size: 16px;
  cursor: pointer;
}
.chip__drop:hover { color: var(--color-danger); }

.attach__pick { display: flex; flex-direction: column; gap: var(--space-2); padding-bottom: var(--space-2); }
.attach__doc {
  align-self: flex-start;
  padding: var(--space-2) var(--space-3);
  border: 1px dashed var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
  color: var(--color-text-soft);
  font-size: var(--text-sm);
  cursor: pointer;
}
.attach__doc:hover { border-color: var(--color-primary); color: var(--color-primary); }
.attach__input { display: none; }
</style>
